import React, { Component } from "react";
import { connect } from "react-redux";
import "../../../assets/style/style.css";
import { requestCastUrl } from "../../actions/actionCast";
import { Container, Row, Col, CardGroup, Card, CardBody,} from "reactstrap";
import Proptypes from "prop-types";
import { withRouter } from "react-router";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import ReCAPTCHA from "react-google-recaptcha";
import { Redirect } from "react-router-dom";
import queryString from "query-string";

class Connect extends Component {
    constructor(props) {
        super(props);
         this.state  = {
             recaptcha_needed: false,
             google_recaptcha_site_key: null,
             doLogin: false,
             brandingSet: false,
             doLocalError: false,
             errorDetails: "",
             kasm_url: null,
             docker_network: null,
        };
        this.handleError = this.handleError.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.onCaptchaChange = this.onCaptchaChange.bind(this);
    }

    componentDidMount() {
        let cast_key = this.props.match.params.cast_key;
        let kasm_url = null;
        let docker_network = null;
        const values = queryString.parse(this.props.location.search);
        if (values.kasm_url) {
            kasm_url = decodeURIComponent(values.kasm_url);
          this.setState({
            kasm_url: decodeURIComponent(values.kasm_url),
          });
        }
        if (values.docker_network) {
            docker_network = decodeURIComponent(values.docker_network);
          this.setState({
            docker_network: decodeURIComponent(values.docker_network),
          });
        }

        this.props.requestCastUrl(cast_key, kasm_url, docker_network, null, window.document.referrer)
            .then(() => this.handleSuccess())
            .catch(() => this.handleError());
    }

    handleSuccess() {
        const {castResponse, requestCastError, requestCastErrorMessage, requestCastRecaptchaSiteKey, castBrandingResponse} = this.props;
        if (castBrandingResponse){
             window.localStorage.setItem("login_logo", castBrandingResponse.login_logo);
             window.localStorage.setItem("login_caption", castBrandingResponse.login_caption);
             window.localStorage.setItem("header_logo", castBrandingResponse.header_logo);
             window.localStorage.setItem("login_splash_background", castBrandingResponse.login_splash_background);
             window.localStorage.setItem("splash_background", castBrandingResponse.splash_background);
             window.localStorage.setItem("html_title", castBrandingResponse.html_title);
             window.localStorage.setItem("favicon_logo", castBrandingResponse.favicon_logo);
             window.localStorage.setItem("loading_session_text", castBrandingResponse.loading_session_text);
             window.localStorage.setItem("joining_session_text", castBrandingResponse.joining_session_text);
             window.localStorage.setItem("destroying_session_text", castBrandingResponse.destroying_session_text);
             window.localStorage.setItem("launcher_background_url", castBrandingResponse.launcher_background_url);
             // Changing the state will force the page to re-render - applying the settings
             this.setState({brandingSet: true})
        }
        if (requestCastError) {
            if (requestCastError === "recaptcha_needed"){
                this.setState({recaptcha_needed:true, google_recaptcha_site_key: requestCastRecaptchaSiteKey})
            }
            else if (requestCastError === "auth_required"){
                this.setState({doLogin: true})
            }
            else{
                if (castResponse && castResponse.error_url){
                    window.location.href = castResponse.error_url;
                }
                else{
                    this.setState({doLocalError: true, errorDetails: requestCastErrorMessage});
                }
            }
        } else {
            window.location.href = castResponse.kasm_url;
        }
    }

    handleError() {
        const {requestCastErrorMessage, castResponse} = this.props;
        if (castResponse && castResponse.error_url){
            window.location.href = castResponse.error_url;
        }
        else{
            this.setState({doLocalError: true, errorDetails: requestCastErrorMessage});
        }
    }

    onCaptchaChange(value){
        this.setState({recaptcha_needed:false});
        this.props.requestCastUrl(this.props.match.params.cast_key, this.state.kasm_url, this.state.docker_network, value, window.document.referrer)
           .then(() => this.handleSuccess())
            .catch(() => this.handleError());

    }

    render() {
        let login_logo = window.localStorage.getItem('login_logo');
        login_logo = login_logo ? login_logo : '/img/logo.svg';
        let powered_by = login_logo != "/img/logo.svg";

        let login_caption = window.localStorage.getItem('login_caption');
        login_caption = login_caption ? login_caption : 'The Container Streaming Platform';

        let login_splash_background = window.localStorage.getItem('login_splash_background');

        let elem = document.getElementById("favicon");
        let favicon_logo = window.localStorage.getItem('favicon_logo');
        if (favicon_logo != undefined){
            elem.href=favicon_logo;
        }

        let html_title = window.localStorage.getItem('html_title');
        if (html_title != undefined){
             document.title=html_title;
        }

        if (this.state.doLogin){
            return <Redirect to={{pathname: "/login", state: {from: this.props.location}}} />
        }
        else if (this.state.doLocalError){
            return <Redirect to={{pathname: "/error", state: {details: this.state.errorDetails}}} />
        }
        else if (this.props.requestCastLoading) {
            return (<div><LoadingSpinner /></div>);
        }
        else if (this.state.recaptcha_needed) {
            return (
               <div className="login_box" style={{backgroundImage: 'url("' + login_splash_background + '")'}}>
                    <div className={"login-flex " + this.state.loginBoxClass}>
                        <div className="cast-outer">
                            <div className="cast-middle">
                                <Container>
                                    <Row className="justify-content-center testMe">
                                        <Col sm="8" md="6" lg="5" xl="4">
                                            <div>
                                                <CardGroup className="mb-0">
                                                    <Card className="text-white card-transparent">
                                                        <div className="logo-wrapper cast-logo-wrapper">
                                                            <div className="logo-center">
                                                                <img src={login_logo} alt="logo" style={{maxWidth: "90%"}}/>
                                                                <CardBody className="text-center">
                                                                     {powered_by ?
                                                                    <div className="smaller-text">
                                                                        <p>Powered by Kasm Workspaces</p>
                                                                    </div>
                                                                    :
                                                                    ""}
                                                                    <div>
                                                                        <h6>{login_caption}</h6>
                                                                    </div>
                                                                    <div style={{paddingTop: "20px", textAlign:"center", display: "inline-block" }}>
                                                                        {this.state.google_recaptcha_site_key ?
                                                                            <ReCAPTCHA
                                                                                sitekey={this.state.google_recaptcha_site_key}
                                                                                onChange={this.onCaptchaChange}
                                                                            />
                                                                            : ""
                                                                        }
                                                                    </div>

                                                                </CardBody>
                                                            </div>
                                                        </div>
                                                    </Card>
                                                </CardGroup>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </div>
                    </div>
                </div>

            );
        }
        else {
            return (
                ""
            );
        }
    }
}

Connect.propTypes = {
    history: Proptypes.object,
};

let ConnectWithRouter = withRouter(Connect);

export default connect(state =>
        ({
            requestCastError: state.cast.requestCastError || null,
            requestCastRecaptchaSiteKey: state.cast.requestCastRecaptchaSiteKey || null,
            castResponse: state.cast.castResponse || null,
            castBrandingResponse: state.cast.castBrandingResponse || null,
            requestCastErrorMessage: state.cast.requestCastErrorMessage || null,
            requestCastLoading: state.requestCastLoading || null
        }),
    dispatch =>
        ({
            requestCastUrl: (cast_key, kasm_url, docker_network, recaptcha_value) => dispatch(requestCastUrl(cast_key, kasm_url, docker_network, recaptcha_value, window.document.referrer)),
        }))(ConnectWithRouter);